import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonLoading from "../buttonLoading";
import { Button } from "@mui/material";

interface IProps {
  message?: string;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function ModalConfirm(props: IProps) {

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirmar"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message ?? "Deseja realmente continuar?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose}>
            CANCELAR
          </Button>
          <ButtonLoading onClick={props.onConfirm}>
            ACEITAR
          </ButtonLoading>
        </DialogActions>
      </Dialog>
    </div>
  );
}
